import img1 from "./images/background/video-img-1.jpg";
import img2 from "./images/illustration/slider-img-2-1024x686.jpg";
import img3 from "./images/illustration/blog-thumb-6-1024x683.jpg";
import img4 from "./images/illustration/blog-thumb-5-1024x683.jpg";
import img5 from "./images/illustration/blog-thumb-4-1024x683.jpg";

const News = () => {
  return (
    <>
      <section className=" container-fluid" id="demo8">
        <section className="container text-center mt-5">
          <section className="row pb-3 pt-3">
            <div className=" col-12">
              <h2 className="heading fw-bold mb-4">BLOG & NEWS</h2>
            </div>
            <div className=" col-12 col-md-6 mt-5">
              <img src={img1} alt="image found" className="img-fluid" />
              <h2>
                We Believe That Our Best Work Creates Value For Our Society
              </h2>
              <p>
                Erat egestas mauris urna rutrum mi eu vitae quam interdum. Quis
                mattis et mi est. Eget commodo orci, lacus blandit scelerisque.
                Feugiat ...
              </p>
            </div>

            <div className=" col-12 col-md-6 mt-5">
              <div className="row row-cols-1 row-cols-md-2 g-4">
                <div className="col">
                  <div className="card">
                    <img src={img2} className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">
                        We Believe That Our Best Work Creates Value For Our
                        Society
                      </h5>
                      <p className="card-text">Aerobics</p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <img src={img3} className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">
                        We Believe That Our Best Work Creates Value For Our
                        Society
                      </h5>
                      <p className="card-text"></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <img src={img4} className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">
                        We Believe That Our Best Work Creates Value For Our
                        Society
                      </h5>
                      <p className="card-text"></p>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className="card">
                    <img src={img5} className="card-img-top" alt="..." />
                    <div className="card-body">
                      <h5 className="card-title">
                        We Believe That Our Best Work Creates Value For Our
                        Society
                      </h5>
                      <p className="card-text"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
      </section>
    </>
  );
};

export default News;
